import { createBrowserRouter } from "react-router";
import RootLayout from "./components/layouts/RootLayout";
import AuthLayout from "./components/layouts/AuthLayout";
import HomePage from "./pages/HomePage";
import SignupPage from "./pages/SignupPage";
import QRCodePage from "./pages/QRCodePage";
import NotFoundPage from "./pages/NotFoundPage";

/**
 * React Router v7 Configuration
 *
 * Route Structure (mirrors Next.js app directory):
 * - / → Home (auto-login & redirect)
 * - /signup → Signup flow
 * - /reload/qrcode → QR code page
 *
 * All routes under /reload require LIFF authentication
 */
export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <NotFoundPage />,
    children: [
      {
        // Auth routes wrapped in AuthLayout (provides LiffProvider)
        element: <AuthLayout />,
        children: [
          {
            index: true,
            element: <HomePage />,
          },
          {
            path: "signup",
            element: <SignupPage />,
          },
          {
            path: "reload",
            children: [
              {
                path: "qrcode",
                element: <QRCodePage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);
